import { useState, useEffect } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { InputContainer } from 'components/ideal-core-ui'
import s from './EditTeamModal.scss'
import { makePutRequest } from 'utils/api'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import { useDispatch } from 'react-redux'
import update from 'immutability-helper'

const EditTeamModal = ({
  toggleEditTeamModal,
  isEditTeamModalVisible,
  editedTeam,
  setTeams,
  teams
}) => {
  const [teamName, setTeamName] = useState('')
  const [teamAbbreviation, setTeamAbbreviation] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    if (editedTeam) {
      setTeamName(editedTeam.name)
      setTeamAbbreviation(editedTeam.abbreviation)
    }
  }, [editedTeam])

  const updateTeam = async () => {
    try {
      makePutRequest(`/v1/teams/${editedTeam.id}`, {
        name: teamName,
        abbreviation: teamAbbreviation
      })
      const index = teams.findIndex(team => team.id === editedTeam.id)
      const newTeams = update(teams, {
        [index]: {
          $set: {
            ...editedTeam,
            name: teamName,
            abbreviation: teamAbbreviation
          }
        }
      })
      setTeams(newTeams)
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'Team updated successfuly',
          level: 'success'
        }
      })
    } catch (e) {
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'There was a problem updating team',
          level: 'error'
        }
      })
    }
  }

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isEditTeamModalVisible}
        toggle={toggleEditTeamModal}
        size="md"
      >
        <ModalHeader toggle={toggleEditTeamModal} className={s.modalHeader}>
          Update this teams name and abbreviation
        </ModalHeader>
        <ModalBody>
          <div className={s.itemWrapper}>
            <InputContainer
              type="text"
              cb={value => setTeamName(value)}
              text={teamName}
              placeholder="Enter Team Name"
              classname={s.addItemInput}
            />
            <InputContainer
              type="text"
              cb={value => setTeamAbbreviation(value)}
              text={teamAbbreviation}
              placeholder="3-letter name (TM1)"
              classname={s.addItemInput}
              maxLength="3"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleEditTeamModal}>
            Cancel
          </Button>
          <Button
            className={s.saveBtn}
            onClick={() => {
              updateTeam()
              toggleEditTeamModal()
            }}
            disabled={teamName === '' || teamAbbreviation === ''}
          >
            Update Team
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default EditTeamModal
